<template>
  <div>
    <!-- Admin Menu -->
    <div v-if="this.user.role === 'admin' || this.user.role === 'superadmin' || this.user.role === 'seller'" class="hidden md:block mb-4">
      <search-input v-model="searchForm.search" class="mr-4 mb-4 w-full max-w-md" :hideResetButton="true"></search-input>
    </div>

    <div class="mb-4">
      <Link v-if="user.role === 'superadmin' || user.role === 'admin'" class="group flex items-center py-3"
            href="/admin/paneli"
      >
        <icon name="dashboard" class="mr-2 w-4 h-4"
              :class="isUrl('admin/paneli') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('admin/paneli') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Paneli</div>
      </Link>
    </div>

    <div class="flex items-center justify-between mb-4">
      <Link v-if="user.role === 'superadmin' || user.role === 'admin'" class="group flex items-center py-3"
            href="/admin/dergesat"
      >
        <icon name="orders" class="mr-2 w-4 h-4"
              :class="isUrl('admin/dergesat') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('admin/dergesat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dërgesat</div>
      </Link>

      <Link v-if="user.role === 'superadmin' || user.role === 'admin'" class="group flex items-center py-3"
            href="/admin/dergesat/krijo"
      >
        <icon name="create" class="mr-2 w-4 h-4"
              :class="isUrl('admin/dergesat/krijo') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
      </Link>

    </div>


    <div v-if="user.role === 'superadmin' || (user.role === 'admin' && user.finances)" class="mb-4">
      <DropdownMenu title="Financat" icon="finances" @click.stop="">
        <li>
          <Link class="group flex items-center py-3" href="/admin/financat/barazimet-me-shofere-shperndares">
            <div
              :class="isUrl('admin/financat/barazimet-me-shofere-shperndares') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Barazimet me shoferë
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/financat/barazimet-me-shites">
            <div
              :class="isUrl('admin/financat/barazimet-me-shites') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Barazimet me shitës
            </div>
          </Link>
        </li>
      </DropdownMenu>
    </div>

    <div class="mb-4">
      <Link v-if="user.role === 'superadmin' || user.role === 'admin'" class="group flex items-center py-3"
            href="/admin/bizneset"
      >
        <icon name="businesses" class="mr-2 w-4 h-4"
              :class="isUrl('admin/bizneset') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('admin/bizneset') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Bizneset</div>
      </Link>
    </div>

    <div v-if="user.role === 'superadmin' || user.role === 'admin'" class="mb-4">
      <DropdownMenu title="Përdoruesit" icon="users" @click.stop="">
        <li>
          <Link class="group flex items-center py-3" href="/admin/perdoruesit/shitesit">
            <div :class="isUrl('admin/perdoruesit/shitesit') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
              • Shitësit
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/perdoruesit/shoferet-shperndares">
            <div
              :class="isUrl('admin/perdoruesit/shoferet-shperndares') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Shoferët shpërndarës
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/perdoruesit/shoferet-mbledhes">
            <div
              :class="isUrl('admin/perdoruesit/shoferet-mbledhes') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Shoferët mbledhës
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/perdoruesit/depoistet">
            <div
              :class="isUrl('admin/perdoruesit/depoistet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Depoistët
            </div>
          </Link>
        </li>
        <li v-if="user.role === 'superadmin'">
          <Link class="group flex items-center py-3" href="/admin/perdoruesit/administratoret">
            <div
              :class="isUrl('admin/perdoruesit/administratoret') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Administratorët
            </div>
          </Link>
        </li>
      </DropdownMenu>
    </div>



    <div v-if="user.role === 'superadmin' || user.role === 'admin'" class="mb-4">
      <DropdownMenu title="Konfigurimet" icon="configuration" @click.stop="">
        <li>
          <Link class="group flex items-center py-3" href="/admin/konfigurimet/shtetet">
            <div
              :class="isUrl('admin/configuration/shtetet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Shtetet
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/konfigurimet/qytetet">
            <div :class="isUrl('admin/konfigurimet/qytetet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
              • Qytetet
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/konfigurimet/regjionet">
            <div
              :class="isUrl('admin/konfigurimet/regjionet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Regjionet e shoferëve
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/konfigurimet/madhesite-e-pakove">
            <div
              :class="isUrl('admin/konfigurimet/madhesite-e-pakove') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Madhësitë e pakove
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/konfigurimet/referencat">
            <div
              :class="isUrl('admin/konfigurimet/referencat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Referencat
            </div>
          </Link>
        </li>
        <li>
          <Link class="group flex items-center py-3" href="/admin/konfigurimet/valutat">
            <div
              :class="isUrl('admin/konfigurimet/valutat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'"
            >• Valutat
            </div>
          </Link>
        </li>
      </DropdownMenu>
    </div>

    <div v-if="user.role === 'superadmin' || user.role === 'admin'" class="mb-4">
      <Link class="group flex items-center py-3" href="/admin/cmimet">
        <icon name="pricing" class="mr-2 w-4 h-4"
              :class="isUrl('admin/cmimet') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('admin/cmimet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Çmimet</div>
      </Link>
    </div>

    <div v-if="user.role === 'superadmin' || user.role === 'admin'" class="mb-4">
      <Link class="group flex items-center py-3" href="/admin/njoftimet">
        <icon name="notifications" class="mr-2 w-4 h-4"
              :class="isUrl('admin/njoftimet') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('admin/njoftimet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Njoftimet</div>
      </Link>
    </div>

    <div v-if="user.role === 'superadmin' || user.role === 'admin'" class="mb-4">
      <Link class="group flex items-center py-3" href="/admin/vleresimet">
        <icon name="reviews" class="mr-2 w-4 h-4"
              :class="isUrl('admin/vleresimet') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('admin/vleresimet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Vlerësimet</div>
      </Link>
    </div>


    <div v-if="user.role === 'superadmin' || user.role === 'admin'" class="mb-4" >
      <DropdownMenu title="Arkivi" icon="archive" @click.stop="">
        <li>
          <Link class="group flex items-center py-3" href="/admin/arkivi/dergesat">
            <div :class="isUrl('admin/arkivi/dergesat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
              • Dërgesat
            </div>
          </Link>
        </li>

        <li>
          <Link class="group flex items-center py-3" href="/admin/arkivi/barazimet-me-shofere">
            <div :class="isUrl('admin/arkivi/barazimet-me-shofere') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
              • Barazimet me shoferë
            </div>
          </Link>
        </li>

        <li>
          <Link class="group flex items-center py-3" href="/admin/arkivi/barazimet-me-shites">
            <div :class="isUrl('admin/arkivi/barazimet-me-shites') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
              • Barazimet me shitës
            </div>
          </Link>
        </li>
      </DropdownMenu>
    </div>

    <!-- Seller Menu -->
    <div class="mb-4">
      <Link v-if="user.role === 'seller'" class="group flex items-center py-3" href="/paneli">
        <icon name="dashboard" class="mr-2 w-4 h-4"
              :class="isUrl('paneli') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('paneli') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Paneli</div>
      </Link>
    </div>

    <div v-if="user.role === 'seller'" class="flex items-center justify-between mb-4">
      <Link class="group flex items-center py-3" href="/dergesat">
        <icon name="orders" class="mr-2 w-4 h-4"
              :class="isUrl('dergesat') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('dergesat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dërgesat</div>
      </Link>

      <Link v-if="user.role === 'seller'" class="group flex items-center py-3"
            href="/dergesat/krijo"
      >
        <icon name="create" class="mr-2 w-4 h-4"
              :class="isUrl('dergesat/krijo') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
      </Link>
    </div>


    <div v-if="user.role === 'seller'" class="mb-4">
      <Link class="group flex items-center py-3" href="/barazimet">
        <icon name="finances" class="mr-2 w-4 h-4"
              :class="isUrl('barazimet') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('barazimet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Barazimet</div>
      </Link>
    </div>

    <div v-if="user.role === 'seller'" class="mb-4">
      <Link class="group flex items-center py-3" href="/cmimet">
        <icon name="pricing" class="mr-2 w-4 h-4"
              :class="isUrl('cmimet') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('cmimet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Çmimet</div>
      </Link>
    </div>

    <div v-if="user.role === 'seller'" class="mb-4">
      <Link class="group flex items-center py-3" href="/valutat">
        <icon name="currencies" class="mr-2 w-4 h-4"
              :class="isUrl('valutat') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('valutat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Valutat</div>
      </Link>
    </div>


    <div v-if="user.role === 'seller' && user.api_enabled" class="mb-4">
      <DropdownMenu title="API & Webhooks" icon="api" @click.stop="">
        <li>
          <Link class="group flex items-center py-3" href="/api/tokens">
            <div :class="isUrl('api/tokens') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">• Tokens</div>
          </Link>
        </li>

        <li>
          <a class="group flex items-center py-3" target="_blank" href="https://documenter.getpostman.com/view/9746263/2sB2qUmPda">
            <div :class="'text-indigo-300 group-hover:text-white'"
            >• Docs
            </div>
          </a>
        </li>

        <li>
          <Link class="group flex items-center py-3" href="/webhooks">
            <div :class="isUrl('webhooks') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">• Webhooks</div>
          </Link>
        </li>
      </DropdownMenu>
    </div>

    <div v-if="user.role === 'seller'" class="mb-4">
      <Link class="group flex items-center py-3" href="/vleresimet">
        <icon name="reviews" class="mr-2 w-4 h-4"
              :class="isUrl('vleresimet') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('vleresimet') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Na vlerëso!</div>
      </Link>
    </div>

    <!-- Seller Menu -->


    <!-- Collecting Driver Menu -->
    <div v-if="user.role === 'collecting_driver'" class="mb-4">
      <Link class="group flex items-center py-3" href="/shofer-mbledhes/paneli">
        <icon name="dashboard" class="mr-2 w-4 h-4"
              :class="isUrl('shofer-mbledhes/paneli') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('shofer-mbledhes/paneli') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Paneli</div>
      </Link>
    </div>

    <div v-if="user.role === 'collecting_driver'" class="mb-4">
      <Link class="group flex items-center py-3" href="/shofer-mbledhes/dergesat">
        <icon name="orders" class="mr-2 w-4 h-4"
              :class="isUrl('shofer-mbledhes/dergesat') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('shofer-mbledhes/dergesat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dërgesat</div>
      </Link>
    </div>


    <div v-if="user.role === 'collecting_driver'" class="mb-4">
      <Link class="group flex items-center py-3" href="/shofer-mbledhes/barazimet-me-shites">
        <icon name="finances" class="mr-2 w-4 h-4"
              :class="isUrl('shofer-mbledhes/barazimet-me-shites') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('shofer-mbledhes/barazimet-me-shites') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Barazimet me shitës</div>
      </Link>
    </div>

    <!-- Collecting Driver Menu -->

    <!-- Delivery Driver Menu -->
    <div v-if="user.role === 'delivery_driver'" class="mb-4">
      <Link class="group flex items-center py-3" href="/shofer-shperndares/paneli">
        <icon name="dashboard" class="mr-2 w-4 h-4"
              :class="isUrl('shofer-shperndares/paneli') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('shofer-shperndares/paneli') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Paneli</div>
      </Link>
    </div>

    <div v-if="user.role === 'delivery_driver'" class="mb-4">
      <Link class="group flex items-center py-3" href="/shofer-shperndares/dergesat">
        <icon name="orders" class="mr-2 w-4 h-4"
              :class="isUrl('shofer-shperndares/dergesat') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('shofer-shperndares/dergesat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dërgesat</div>
      </Link>
    </div>


    <div v-if="user.role === 'delivery_driver'" class="mb-4">
      <Link class="group flex items-center py-3" href="/shofer-shperndares/barazimet-me-baze">
        <icon name="finances" class="mr-2 w-4 h-4"
              :class="isUrl('shofer-shperndares/barazimet-me-baze') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('shofer-shperndares/barazimet-me-baze') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Barazimet me bazë</div>
      </Link>
    </div>
    <!-- Delivery Driver Menu -->

    <!-- Warehouseman Menu -->
    <div v-if="user.role === 'warehouseman'" class="mb-4">
      <Link class="group flex items-center py-3" href="/depoist/paneli">
        <icon name="dashboard" class="mr-2 w-4 h-4"
              :class="isUrl('depoist/paneli') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('depoist/paneli') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Paneli</div>
      </Link>
    </div>

    <div v-if="user.role === 'warehouseman'" class="mb-4">
      <Link class="group flex items-center py-3" href="/depoist/dergesat">
        <icon name="orders" class="mr-2 w-4 h-4"
              :class="isUrl('depoist/dergesat') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"
        />
        <div :class="isUrl('depoist/dergesat') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dërgesat</div>
      </Link>
    </div>

    <!-- Warehouseman Menu -->


    <Teleport to="body">
      <!-- use the modal component, pass in the prop -->
      <modal v-bind:show="showSearchResultModal" @close="showSearchResultModal = false">
        <template #header>
          <div class="mb-4">
            <search-input v-model="searchForm.search" ref="tableSearch" class="mr-4 mb-4 w-full max-w-md " :hideResetButton="true"></search-input>
          </div>
        </template>

        <template #body>
          <div class="flex flex-wrap">
            <div class="bg-white rounded-md shadow overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                <thead>
                <tr class="text-left font-bold">
                  <th class="pb-4 pt-6 px-2"></th>
                  <th  class="pb-4 pt-6 px-2 cursor-pointer">ID</th>
                  <th  class="pb-4 pt-6 px-2 cursor-pointer">ID tjetër</th>
                  <th  class="pb-4 pt-6 px-2 cursor-pointer">Statusi</th>
                  <th class="pb-4 pt-6 px-2 cursor-pointer">Emri i blerësit</th>
                  <th class="pb-4 pt-6 px-2">Telefoni i blerësit</th>
                  <th  class="pb-4 pt-6 px-2 cursor-pointer">Produkti</th>
                  <th  class="pb-4 pt-6 px-2 cursor-pointer">Çmimi</th>
                  <th class="pb-4 pt-6 px-2 cursor-pointer">Qyteti</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="order in searchOrders" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100">


                  <td class="w-px border-t">
                    <Link class="flex items-center  px-2 py-4" :href="this.getOrderShowUrl(order.id)" @click="showSearchResultModal = false" tabindex="-1">
                      <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                      <icon v-if="order.barazim_id" name="paid" class="flex-shrink-0 ml-2 w-5 h-5 fill-gray-400" />
                    </Link>
                  </td>

                  <td class="border-t px-2">
                    {{ order.id }}
<!--                    <icon v-if="order.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />-->
<!--                    <small v-if="order.is_change" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">NDËRRIM</small>-->
<!--                    <small v-if="order.is_cash && order.has_product" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">CASH</small>-->
<!--                    <icon v-if="order.product_returned" name="checkmark" class="block w-6 h-6 fill-green-600" title="Produkti eshte kthyer" />-->
<!--                    <small v-if="order.is_recreated" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">RINISJE</small>-->
<!--                    <small v-if="order.parent_id" class="mx-0.5 px-2 py-1 rounded-md bg-indigo-300">BASHKIM</small>-->
                  </td>
                  <td class="border-t px-2">
                    {{ order.custom_id }}
                  </td>
                  <td class="border-t px-2">
              <span class="mx-0.5 px-2 py-1 rounded-md text-white" v-bind:class="getStatusColor(order.status.id)">
                {{ order.status.name }}
              </span>
                  </td>
                  <td class="border-t px-2">
                    {{ order.name }}
                  </td>
                  <td class="border-t px-2">
                    {{ order.phone }}
                  </td>
                  <td class="border-t px-2">
                    {{ order.product_name }}
                  </td>

                  <td class="border-t px-2">
                    {{ order.product_price }}
                  </td>

                  <td class="border-t px-2">
                    {{ order.city.name }}
                  </td>
                </tr>

                <tr v-if="searchOrders.length === 0">
                  <td class="px-6 py-4 border-t" colspan="14">Nuk u gjet asnje dërgesë.</td>
                </tr>
                </tbody>
              </table>
            </div>



          </div>
        </template>

        <template #footer>
          <div class="flex flex-wrap">
            <loading-button class="btn-indigo bg-red-500"
                            @click="showSearchResultModal = false"
            >Mbyll
            </loading-button>
          </div>
        </template>
      </modal>
    </Teleport>

  </div>


</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import DropdownMenu from '@/Shared/DropdownMenu'
import {usePage} from '@inertiajs/inertia-vue3'
import {computed} from 'vue'
import SearchInput from '@/Shared/SearchInput'
import axios from 'axios'
import Modal from '@/Shared/Modal'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    DropdownMenu,
    Icon,
    Link,
    SearchInput,
    Modal,
    LoadingButton
  },
  props: {
  },
  data() {
    return {
      dropdownPopoverShow: false,
      showSearchResultModal: false,
      searchOrders: [],
      searchForm: this.$inertia.form({
        search: '',
      }),
    }
  },
  watch: {
    'searchForm.search'(newValue){
      if(newValue === ''){
        this.showSearchResultModal = false;
        return;
      }

      let self = this;
      this.searchForm.search = newValue;

      axios.get('/ajax/search/orders',{
        params: {
          search: this.searchForm.search,
        }
      }).then(function (result){
        self.searchOrders = result.data.orders;
        self.showSearchResultModal = true;
      }).then(function (){
        self.$refs.tableSearch.$el.querySelector('div input').focus()
      });
    },
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
    getStatusColor(orderId){
      let statusColor = 'bg-indigo-500'
      if(orderId === 1)
        statusColor = 'bg-yellow-500'

      if(orderId === 3)
        statusColor = 'bg-orange-500'

      if(orderId === 4)
        statusColor = 'bg-indigo-900'

      if(orderId === 5)
        statusColor = 'bg-green-500'

      if(orderId === 6)
        statusColor = 'bg-yellow-700'

      if(orderId === 7)
        statusColor = 'bg-red-500'

      if(orderId === 8)
        statusColor = 'bg-gray-400'

      if(orderId === 9)
        statusColor = 'bg-green-500'

      return statusColor
    },
    getOrderShowUrl(orderId){
      if(this.user.role === 'seller')
        return '/dergesat/' + orderId;
      else if (this.user.role === 'admin' || this.user.role === 'superadmin')
        return '/admin/dergesat/' + orderId;
      else return '';
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)

    return {user}
  },
}
</script>
